import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import store from '@/store'


export default new Router({
  routes: [
    {
      path: '/',
      component: resolve => require(['../components/common/home.vue'], resolve),
      redirect: () => {
        return store.state.router //解决动态路由问题
      },
      meta: { title: '导航菜单' },
      children: [
        {
          path: '/operateHome',
          component: resolve => require(['../components/pages/operatepages/adminHome/operateHome'], resolve),
          meta: { title: '系统首页' }
        },
        {
          path: '/city',
          component: resolve => require(['../components/pages/operatepages/adminHome/city'], resolve),
          meta: { title: '城市详情' }
        },
        {
          path: '/district',
          component: resolve => require(['../components/pages/operatepages/adminHome/district'], resolve),
          meta: { title: '区县详情' }
        },
        {
          path: '/homeDetail',
          component: resolve => require(['../components/pages/operatepages/adminHome/homeDetail'], resolve),
          meta: { title: '柜机详情' }
        },
        {
          path: '/province',
          component: resolve => require(['../components/pages/operatepages/adminHome/province'], resolve),
          meta: { title: '省市详情' }
        }, {
          path: '/abnormal',
          component: resolve => require(['../components/pages/operatepages/dashboardIndex/abnormal'], resolve),
          meta: { title: '异常提醒' }
        }, {
          path: '/agent',
          component: resolve => require(['../components/pages/operatepages/index/agent'], resolve),
          meta: { title: '统计汇总' }
        }, {
          path: '/deviceAutho',
          component: resolve => require(['../components/pages/operatepages/deviceManagement/deviceAutho'], resolve),
          meta: { title: '设备授权' }
        }, {
          path: '/deviceDetails',
          component: resolve => require(['../components/pages/operatepages/deviceManagement/deviceDetails'], resolve),
          meta: { title: '设备授权详情' }
        }, {
          path: '/cabinetMange',
          redirect: '/cabinetRegister',
          component: resolve => require(['../components/pages/operatepages/deviceManagement/cabinetMange'], resolve),
          meta: { title: '柜机管理' },
          children: [
            {                                     //三级路由
              path: '/cabinetRegister',
              name: '/cabinetRegister',
              meta: { title: '柜机注册' },
              component: resolve => require(['../components/pages/operatepages/deviceManagement/cabinetRegister'], resolve),
            }, {                                     //三级路由
              path: '/registerDetails',
              name: '/registerDetails',
              meta: { title: '注册详情' },
              component: resolve => require(['../components/pages/operatepages/deviceManagement/registerDetails'], resolve),
            }, {                                     //三级路由
              path: '/cabinetDispose',
              name: '/cabinetDispose',
              meta: { title: '柜机分配' },
              component: resolve => require(['../components/pages/operatepages/deviceManagement/cabinetDispose'], resolve),
            }, {
              path: '/lockDetails',
              name: 'lockDetails',
              meta: { title: '格口锁定详情' },
              component: resolve => require(['../components/pages/operatepages/deviceManagement/lockDetails'], resolve),
            }, {
              path: '/latticeList',
              name: 'latticeList',
              meta: { title: '格口操作' },
              component: resolve => require(['../components/pages/operatepages/deviceManagement/latticeList'], resolve),
            }, {
              path: '/remoteMonitor',
              name: 'remoteMonitor',
              meta: { title: '远程监控' },
              component: resolve => require(['../components/pages/operatepages/deviceManagement/remoteMonitor'], resolve),
            },
            {
              path: '/virtual',
              name: 'virtual',
              meta: { title: '虚拟操作' },
              component: resolve => require(['../components/pages/operatepages/deviceManagement/virtual'], resolve),
            }, {
              path: '/cabinetDetails',
              name: 'cabinetDetails',
              meta: { title: '柜机配置详情' },
              component: resolve => require(['../components/pages/operatepages/deviceManagement/cabinetDetails'], resolve),
            },
            {
              path: '/configuration',
              name: 'configuration',
              meta: { title: '柜机配置' },
              component: resolve => require(['../components/pages/operatepages/deviceManagement/configuration'], resolve),
            },
            {
              path: '/addNewProfile',
              name: 'addNewProfile',
              meta: { title: '配置' },
              component: resolve => require(['../components/pages/operatepages/deviceManagement/addNewProfile'], resolve),
            }, {
              path: '/newLattice',
              name: 'newLattice',
              meta: { title: '编辑格口操作' },
              component: resolve => require(['../components/pages/operatepages/deviceManagement/newLattice'], resolve),
            },
            {
              path: '/inventoryDetails',
              name: 'inventoryDetails',
              meta: { title: '库存' },
              component: resolve => require(['../components/pages/operatepages/deviceManagement/inventoryDetails'], resolve),
            },
          ]
        }, {
          path: '/account',
          name: 'account',
          meta: { title: '账号管理' },
          component: resolve => require(['../components/pages/operatepages/customerManage/account'], resolve),
        }, {
          path: '/newAccount',
          name: 'cabbinetAutho',
          meta: { title: '编辑账号' },
          component: resolve => require(['../components/pages/operatepages/customerManage/newAccount'], resolve),
        },
        {
          path: '/manageFunctions',
          component: resolve => require(['../components/pages/operatepages/customerManage/manageFunctions'], resolve),
          meta: { title: '功能管理' }
        }, {
          path: '/clerks',
          name: 'clerks',
          meta: { title: '店员列表' },
          component: resolve => require(['../components/pages/operatepages/customerManage/clerks'], resolve),
        },
        {
          path: '/roleManage',
          component: resolve => require(['../components/pages/operatepages/customerManage/roleManage'], resolve),
          meta: { title: '角色管理' }
        },
        {
          path: '/apply',
          name: 'apply',
          meta: { title: '店员申请列表' },
          component: resolve => require(['../components/pages/operatepages/customerManage/apply'], resolve),
        }, {
          path: '/addStaff',
          name: 'addStaff',
          meta: { title: '创建角色' },
          component: resolve => require(['../components/pages/operatepages/customerManage/addStaff'], resolve),
        }, {
          path: '/product',
          name: 'product',
          meta: { title: '产品管理' },
          component: resolve => require(['../components/pages/operatepages/customerManage/product'], resolve),
        }, {
          path: '/newProduct',
          name: 'newProduct',
          meta: { title: '编辑产品' },
          component: resolve => require(['../components/pages/operatepages/customerManage/newProduct'], resolve),
        }, {
          path: '/storeManagement',
          name: 'storeManagement',
          meta: { title: '店铺管理' },
          component: resolve => require(['../components/pages/operatepages/customerManage/storeManagement'], resolve),
        }, {
          path: '/commodityGroup',
          name: 'commodityGroup',
          meta: { title: '商品分组管理' },
          component: resolve => require(['../components/pages/operatepages/customerManage/commodityGroup'], resolve),
        }, {
          path: '/newcommodityGroup',
          name: 'newcommodityGroup',
          meta: { title: '新建商品分组' },
          component: resolve => require(['../components/pages/operatepages/customerManage/newcommodityGroup'], resolve),
        },
        {
          path: '/rentGoods',
          name: 'rentGoods',
          meta: { title: '商品管理' },
          component: resolve => require(['../components/pages/operatepages/customerManage/rentGoods'], resolve),
        },
        {
          path: '/outGoodDetail',
          name: 'outGoodDetail',
          meta: { title: '虚拟商品管理' },
          component: resolve => require(['../components/pages/operatepages/customerManage/outGoodDetail'], resolve),
        },
        {
          path: '/newRentGoods',
          name: '创建套餐',
          meta: { title: '创建单品' },
          component: resolve => require(['../components/pages/operatepages/customerManage/newRentGoods'], resolve),
        },
        {
          path: '/setMeal',
          name: '创建套餐',
          meta: { title: '创建套餐' },
          component: resolve => require(['../components/pages/operatepages/customerManage/setMeal'], resolve),
        }, {
          path: '/storeEveryDetails',
          name: 'storeEveryDetails',
          meta: { title: '店铺详情' },
          component: resolve => require(['../components/pages/operatepages/customerManage/storeEveryDetails'], resolve),
        },
        {
          path: '/skuList',
          name: 'skuList',
          meta: { title: 'SKU列表' },
          component: resolve => require(['../components/pages/operatepages/customerManage/skuList'], resolve),
        },
        {
          path: '/newSku',
          name: 'newSku',
          meta: { title: '编辑SKU' },
          component: resolve => require(['../components/pages/operatepages/customerManage/newSku'], resolve),
        },
        {
          path: '/skuFormList',
          name: 'skuFormList',
          meta: { title: 'SKU组成管理' },
          component: resolve => require(['../components/pages/operatepages/customerManage/skuFormList'], resolve),
        },
        {
          path: '/newFormSku',
          name: 'newFormSku',
          meta: { title: 'SKU组成管理' },
          component: resolve => require(['../components/pages/operatepages/customerManage/newFormSku'], resolve),
        },
        {
          path: '/skuMoneyList',
          name: 'skuMoneyList',
          meta: { title: 'SKU费用管理' },
          component: resolve => require(['../components/pages/operatepages/customerManage/skuMoneyList'], resolve),
        },
        {
          path: '/newSkuMoney',
          name: 'newSkuMoney',
          meta: { title: 'SKU费用管理' },
          component: resolve => require(['../components/pages/operatepages/customerManage/newSkuMoney'], resolve),
        },
        {
          path: '/skuTipsList',
          name: 'skuTipsList',
          meta: { title: 'SKU提示管理' },
          component: resolve => require(['../components/pages/operatepages/customerManage/skuTipsList'], resolve),
        },
        {
          path: '/newSkuTips',
          name: 'newSkuTips',
          meta: { title: 'SKU提示编辑' },
          component: resolve => require(['../components/pages/operatepages/customerManage/newSkuTips'], resolve),
        },
        {
          path: '/spuList',
          name: 'spuList',
          meta: { title: 'SPU列表' },
          component: resolve => require(['../components/pages/operatepages/customerManage/spuList'], resolve),
        },
        {
          path: '/doctorList',
          name: 'doctorList',
          meta: { title: '医生列表' },
          component: resolve => require(['../components/pages/operatepages/customerManage/doctorList'], resolve),
        },
        {
          path: '/newDoctor',
          name: 'newDoctor',
          meta: { title: '编辑医生' },
          component: resolve => require(['../components/pages/operatepages/customerManage/newDoctor'], resolve),
        },
        {
          path: '/renterDoctor',
          name: 'renterDoctor',
          meta: { title: '导入医生' },
          component: resolve => require(['../components/pages/operatepages/customerManage/renterDoctor'], resolve),
        },
        {
          path: '/newSpuData',
          name: 'newSpuData',
          meta: { title: 'SPU编辑' },
          component: resolve => require(['../components/pages/operatepages/customerManage/newSpuData'], resolve),
        },
        {
          path: '/refundList',
          component: resolve => require(['../components/pages/operatepages/statis/refundList'], resolve),
          meta: { title: '退款申请' }
        },
        {
          path: '/refundListCheck',
          component: resolve => require(['../components/pages/operatepages/statis/refundListCheck'], resolve),
          meta: { title: '退款申请' }
        },
        {
          path: '/refundDetail',
          component: resolve => require(['../components/pages/operatepages/statis/refundDetail'], resolve),
          meta: { title: '退款详情' }
        },
        {
          path: '/refundDetails',
          component: resolve => require(['../components/pages/operatepages/statis/refundDetails'], resolve),
          meta: { title: '退款详情' }
        },
        {
          path: '/allOrder',
          component: resolve => require(['../components/pages/operatepages/statis/allOrder'], resolve),
          meta: { title: '订单明细' }
        },
        {
          path: '/refundRent',
          component: resolve => require(['../components/pages/operatepages/statis/refundRent'], resolve),
          meta: { title: '销售退款' }
        },
        {
          path: '/refund',
          component: resolve => require(['../components/pages/operatepages/statis/refund'], resolve),
          meta: { title: '订单退款' }
        },
        {
          path: '/sameDayOrder',
          component: resolve => require(['../components/pages/operatepages/statis/sameDayOrder'], resolve),
          meta: { title: '当天租赁' }
        }, {
          path: '/orderRentDetails',
          component: resolve => require(['../components/pages/operatepages/statis/orderRentDetails'], resolve),
          meta: { title: '订单详情' }
        }, {
          path: '/diversion',
          name: 'diversion',
          meta: { title: '店员导流' },
          component: resolve => require(['../components/pages/operatepages/Diversion/diversion'], resolve),
        },
        {
          path: '/diversionDetails',
          name: 'diversionDetails',
          meta: { title: '导流信息' },
          component: resolve => require(['../components/pages/operatepages/Diversion/diversionDetails'], resolve),
        },
        {
          path: '/storeDiversion',
          name: 'storeDiversion',
          meta: { title: '店铺导流' },
          component: resolve => require(['../components/pages/operatepages/Diversion/storeDiversion'], resolve),
        },
        {
          path: '/storeDiversionDetails',
          name: 'storeDiversionDetails',
          meta: { title: '店铺导流详情' },
          component: resolve => require(['../components/pages/operatepages/Diversion/storeDiversionDetails'], resolve),
        },
        {
          path: '/coupon',
          name: 'coupon',
          meta: { title: '优惠券' },
          component: resolve => require(['../components/pages/operatepages/Diversion/coupon'], resolve),
        },
        {
          path: '/couponDetails',
          name: 'couponDetails',
          meta: { title: '优惠券详情' },
          component: resolve => require(['../components/pages/operatepages/Diversion/couponDetails'], resolve),
        },
        {
          path: '/userComplaints',
          name: 'userComplaints',
          meta: { title: '用户投诉' },
          component: resolve => require(['../components/pages/operatepages/Diversion/userComplaints'], resolve),
        },
        {
          path: '/userComplaintsDetail',
          name: 'userComplaintsDetail',
          meta: { title: '用户投诉详情' },
          component: resolve => require(['../components/pages/operatepages/Diversion/userComplaintsDetail'], resolve),
        },
        {
          path: '/operation',
          name: 'operation',
          meta: { title: '运营区域管理' },
          component: resolve => require(['../components/pages/operatepages/Diversion/operation'], resolve),
        },
        {
          path: '/operationDetails',
          name: 'operationDetails',
          meta: { title: '运营区域管理' },
          component: resolve => require(['../components/pages/operatepages/Diversion/operationDetails'], resolve),
        },
        {
          path: '/sendActivityMessage',
          name: 'sendActivityMessage',
          meta: { title: '推送活动' },
          component: resolve => require(['../components/pages/operatepages/Diversion/sendActivityMessage'], resolve),
        },
        {
          path: '/weChartAdmin',
          name: 'weChartAdmin',
          meta: { title: '微信公众号' },
          component: resolve => require(['../components/pages/operatepages/Diversion/weChartAdmin'], resolve),
        },
        {
          path: '/financeList',
          name: 'financeList',
          meta: { title: '财务管理' },
          component: resolve => require(['../components/pages/operatepages/finance/financeList'], resolve),
        },
        {
          path: '/financeEdit',
          name: 'financeEdit',
          meta: { title: '财务配置' },
          component: resolve => require(['../components/pages/operatepages/finance/financeEdit'], resolve),
        }, {
          path: '/financeAdmin',
          name: 'financeAdmin',
          meta: { title: '订单结算' },
          component: resolve => require(['../components/pages/operatepages/finance/financeAdmin'], resolve),
        },
        {
          path: '/hospitalSettlement',
          name: 'hospitalSettlement',
          meta: { title: '医院结算' },
          component: resolve => require(['../components/pages/operatepages/finance/hospitalSettlement'], resolve),
        }, {
          path: '/agentSettlement',
          name: 'agentSettlement',
          meta: { title: '代理商结算' },
          component: resolve => require(['../components/pages/operatepages/finance/agentSettlement'], resolve),
        },
        {
          path: '/newHospital',
          name: 'newHospital',
          meta: { title: '编辑转账管理' },
          component: resolve => require(['../components/pages/operatepages/finance/newHospital'], resolve),
        },
        {
          path: '/accountsAdmin',
          redirect: '/accountsHospital',
          component: resolve => require(['../components/pages/operatepages/finance/accountsAdmin'], resolve),
          meta: { title: '转账管理' },
          children: [
            {
              path: '/accountsHospital',
              name: 'accountsHospital',
              meta: { title: '医院转账管理' },
              component: resolve => require(['../components/pages/operatepages/finance/accountsHospital'], resolve),
            }, {
              path: '/accountsAgent',
              name: 'accountsAgent',
              meta: { title: '代理商转账管理' },
              component: resolve => require(['../components/pages/operatepages/finance/accountsAgent'], resolve),
            }
          ]
        },
        {
          path: '/dailyReport',
          name: 'dailyReport',
          meta: { title: '订单日报' },
          component: resolve => require(['../components/pages/operatepages/storeAdmin/dailyReport'], resolve),
        },
        {
          path: '/weeklyReport',
          name: 'weeklyReport',
          meta: { title: '运营周报' },
          component: resolve => require(['../components/pages/operatepages/storeAdmin/weeklyReport'], resolve),
        },
        {
          path: '/settlementReport',
          name: 'settlementReport',
          meta: { title: '柜机月度结算单' },
          component: resolve => require(['../components/pages/operatepages/storeAdmin/settlementReport'], resolve),
        },
        {
          path: '/caiwuReport',
          name: 'caiwuReport',
          meta: { title: '财务月度结算账单' },
          component: resolve => require(['../components/pages/operatepages/storeAdmin/caiwuReport'], resolve),
        },
        {
          path: '/stockReport',
          name: 'stockReport',
          meta: { title: '库存周报' },
          component: resolve => require(['../components/pages/operatepages/storeAdmin/stockReport'], resolve),
        },
        {
          path: '/updateTemplateFile',
          name: 'updateTemplateFile',
          meta: { title: '更新模板文件' },
          component: resolve => require(['../components/pages/operatepages/storeAdmin/updateTemplateFile'], resolve),
        },
        {
          path: '/replaceBIFile',
          name: 'replaceBIFile',
          meta: { title: '更新模板文件' },
          component: resolve => require(['../components/pages/operatepages/storeAdmin/replaceBIFile'], resolve),
        },
        {
          path: '/profitReport',
          name: 'profitReport',
          meta: { title: '自营销售提成报表' },
          component: resolve => require(['../components/pages/operatepages/storeAdmin/profitReport'], resolve),
        },
        {
          path: '/scanDailyReport',
          name: 'scanDailyReport',
          meta: { title: '扫码转化率日报' },
          component: resolve => require(['../components/pages/operatepages/storeAdmin/scanDailyReport'], resolve),
        },
        {
          path: '/jixiaoReport',
          name: 'jixiaoReport',
          meta: { title: '绩效报表' },
          component: resolve => require(['../components/pages/operatepages/storeAdmin/jixiaoReport'], resolve),
        },
        {
          path: '/rewardReport',
          name: 'rewardReport',
          meta: { title: '奖金报表' },
          component: resolve => require(['../components/pages/operatepages/storeAdmin/rewardReport'], resolve),
        },
        {
          path: '/crmMonthlyReport',
          name: 'crmMonthlyReport',
          meta: { title: '客户统计月报' },
          component: resolve => require(['../components/pages/operatepages/storeAdmin/crmMonthlyReport'], resolve),
        },
        {
          path: '/productManage',
          name: 'productManage',
          meta: { title: '产品管理' },
          component: resolve => require(['../components/pages/operatepages/productAdmin/productManage'], resolve),
          redirect: "/taskProduct",
          children: [
            {
              path: '/taskProduct',
              name: 'taskProduct',
              meta: { title: '任务产品' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/taskProduct'], resolve),
            },
            {
              path: '/newProducts',
              name: 'newProduct',
              meta: { title: '编辑任务产品' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/newProduct'], resolve),
            },
            {
              path: '/optionProduct',
              name: 'optionProduct',
              meta: { title: '测试项产品' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/optionProduct'], resolve),
            },
            {
              path: '/newOptionProduct',
              name: 'newOptionProduct',
              meta: { title: '编辑测试项产品' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/newOptionProduct'], resolve),
            }
          ]
        },
        {
          path: '/taskQuery',
          name: 'taskQuery',
          meta: { title: '任务查询' },
          component: resolve => require(['../components/pages/operatepages/queryAdmin/taskQuery'], resolve),
        },
        {
          path: '/lookTaskDetail',
          name: 'lookTaskDetail',
          meta: { title: '查询详情' },
          component: resolve => require(['../components/pages/operatepages/queryAdmin/lookTaskDetail'], resolve),
        },
        {
          path: '/orderManage',
          name: 'orderManage',
          meta: { title: '生产订单管理' },
          component: resolve => require(['../components/pages/operatepages/productAdmin/orderManage'], resolve),
          redirect: '/marketOrder',
          children: [
            {
              path: '/marketOrder',
              name: 'marketOrder',
              meta: { title: '市场订单' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/marketOrder'], resolve),
            }, {
              path: '/planOrder',
              name: 'planOrder',
              meta: { title: '计划生产订单' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/planOrder'], resolve),
            },
            {
              path: '/newMarket',
              name: 'newMarket',
              meta: { title: '新建订单' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/newMarket'], resolve),
            },
          ]
        },
        {
          path: '/processManage',
          name: 'processManage',
          meta: { title: '工序管理' },
          component: resolve => require(['../components/pages/operatepages/productAdmin/processManage'], resolve),
        },
        {
          path: '/newProcess',
          name: 'newProcess',
          meta: { title: '编辑工序' },
          component: resolve => require(['../components/pages/operatepages/productAdmin/component/process/newProcess'], resolve),
          redirect: '/processRelation',
          children: [
            {
              path: '/processRelation',
              name: 'processRelation',
              meta: { title: '模板信息' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/component/process/processRelation'], resolve),
            }, {
              path: '/processDetail',
              name: 'processDetail',
              meta: { title: '模板步骤' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/component/process/processDetail'], resolve),
            }, {
              path: '/processProject',
              name: 'processProject',
              meta: { title: '步骤测试项' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/component/process/processProject'], resolve),
            }, {
              path: '/processCommon',
              name: 'processCommon',
              meta: { title: '测试项命令' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/component/process/processCommon'], resolve),
            },
          ]
        },
        {
          path: '/taskPlan',
          name: 'taskPlan',
          meta: { title: '任务计划' },
          component: resolve => require(['../components/pages/operatepages/productAdmin/taskPlan'], resolve),
        },
        {
          path: '/newTask',
          name: 'newTask',
          meta: { title: '新建任务' },
          component: resolve => require(['../components/pages/operatepages/productAdmin/newTask'], resolve),
          redirect: '/taskRelation',
          children: [
            {
              path: '/taskRelation',
              name: 'taskRelation',
              meta: { title: '任务信息' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/component/tsak/taskRelation'], resolve),
            }, {
              path: '/taskNews',
              name: 'taskNews',
              meta: { title: '任务步骤' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/component/tsak/taskNews'], resolve),
            },
            {
              path: '/taskProject',
              name: 'taskProject',
              meta: { title: '步骤测试项' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/component/tsak/taskProject'], resolve),
            },
            {
              path: '/taskCommon',
              name: 'taskCommon',
              meta: { title: '测试项命令' },
              component: resolve => require(['../components/pages/operatepages/productAdmin/component/tsak/taskCommon'], resolve),
            },
          ]
        },
      ]
    }, {
      path: '/Login',
      component: resolve => require(['../components/login/Login.vue'], resolve)
    },
  ]
});





// WEBPACK FOOTER //
// ./src/router/index.js